import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchMeetingAbsenceProof = (
  meetingId: string,
  userId: string,
  setAbsenceProof: Function,
  setLoaded: Function,
  language: string
) => {
  ApiService.get(`meetings/${meetingId}/absence-proofs/${userId}?fetch_user_flags=true`)
    .then((response) => {
      setAbsenceProof(response.data.meeting_absence_proof);
    })
    .catch((error) => {
      console.error("Error fetching absence proof:", error);
      alert(translate(language, "PAGES.MEETING_ABSENCE_PROOFS.ALERT.ERROR_LOADING_PROOF"));
    })
    .finally(() => {
      setLoaded(true);
    });
};

export const updateAbsenceProofStatus = (
  meetingId: string,
  userId: string,
  status: "validated" | "declined" | "present",
  onSuccess: Function,
  setLoading: Function,
  language: string
) => {
  const payload: { status: string; attendance_status?: boolean } = {
    status: status === "present" ? "validated" : status,
  };

  if (["validated", "present"].includes(status)) {
    payload.attendance_status = status === "present";
  }

  ApiService.put(`meetings/${meetingId}/absence-proofs/${userId}/status`, payload)
    .then(() => {
      alert(translate(language, `PAGES.MEETING_ABSENCE_PROOFS.ALERT.STATUS_${status.toUpperCase()}`));
      onSuccess();
    })
    .catch((error) => {
      console.error("Error updating absence proof status:", error);
      alert(translate(language, "PAGES.MEETING_ABSENCE_PROOFS.ALERT.STATUS_UPDATE_FAILED"));
    })
    .finally(() => {
      setLoading(false);
    });
};
